import { Popover, Grid } from 'antd';
import { ReactComponent as Info } from '../../../../Icons/info-outlined.svg';
import styles from './PortalButton.module.scss';
import { TFunction } from 'i18next';

const { useBreakpoint } = Grid;

function PortalContent({ t }: {t: TFunction}) {
	return (
		<div className={styles.findPortal}>
			<div className={styles.findPortal__title}>
				{t('auth.layout.portal.title')}
			</div>

			<div className={styles.findPortal__info}>
				<p>
					{t('auth.layout.portal.urlLabel')}{' '}
					<span className={styles.url}>system.venza.io/company</span>
				</p>

				<p>
					{t('auth.layout.portal.replacePrefix')}{' '}
					<strong>{t('auth.layout.portal.replaceValue')}</strong>{' '}
					{t('auth.layout.portal.replaceSuffix')}
				</p>
			</div>

			<div className={styles.findPortal__help}>
				<p className={styles.findPortal__helpTitle}>
					{t('auth.layout.portal.helpTitle')}
				</p>
				<p>{t('auth.layout.portal.helpText')}</p>
				<ul>
					<li>{t('auth.layout.portal.admin')}</li>
					<li>{t('auth.layout.portal.support')}</li>
				</ul>
			</div>
		</div>
	);
}

function PortalButton({ t }: {t: TFunction}) {
	const screens = useBreakpoint();
	const isMobile = !screens.md;

	return (
		<Popover
			style={{ color: '#000' }}
			overlayInnerStyle={{
				width: isMobile ? 290 : 515,
				padding: isMobile ? 0 : '12px 8px',
				backgroundColor: 'white'
			}}
			trigger="click"
			content={<PortalContent t={t} />}
		>
			<div
				className={styles.root}
				role="button"
				tabIndex={0}
				aria-label="Find your portal"
			>
				<Info aria-hidden="true" />
				<span>{t('auth.layout.lookingForButton')}</span>
			</div>
		</Popover>
	);
}

export default PortalButton;
